import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RaceSessionService } from '../timing-tower/race-session.service';

export const raceActiveGuard: CanActivateFn = (route) => {
	const raceSessionService = inject(RaceSessionService);
	const router = inject(Router);

	if (raceSessionService.raceTeamsPosition().length === 0) {
		return router.createUrlTree(['/pre-race'], {
			queryParams: route.queryParams,
		});
	}

	return true;
};
